import React from 'react';
import { observer } from 'mobx-react';
import { Loader } from '@consta/uikit/Loader';
import classNames from 'classnames';
import './DelayedLoader.scss';

@observer
export class DelayedLoader extends React.Component {
	render() {
		const className = classNames('DelayedLoader', this.props.className);
		return <Loader className={className} />;
	}
}
